/* eslint-disable */
import { isUndefined } from 'lodash';
import { toApiDate } from '../DateTime';

export default function serialize(obj, prefix) {
  const str = [];
  let key;

  for (key in obj) {
    // A Date is `typeof 'object'`, so it used to fall into the recursion
    // below, which found no own enumerable properties and emitted an empty
    // string — the filter silently vanished. Send the calendar day instead,
    // the same shape request bodies use (CREW-1162).
    const value = obj[key] instanceof Date ? toApiDate(obj[key]) : obj[key];
    const shouldSearialize = !isUndefined(value) && (
      value !== ''
    );

    if (obj.hasOwnProperty(key) && shouldSearialize) {
      const serializedKey = prefix ? `${prefix}[${key}]` : key;

      str.push(
        (value !== null && typeof value === 'object')
          ? serialize(value, serializedKey)
          : `${encodeURIComponent(serializedKey)}=${encodeURIComponent(value)}`,
      );
    }
  }
  return str.join('&');
}
